import styled from "styled-components";
import { BORDERS } from "variables/theme";

export const Wrapper = styled.div`
  border-bottom: ${BORDERS.generic};
`;
